import React, { PropsWithChildren, ReactNode } from "react";

import { css, cx } from "@emotion/css";
import { QueryAwait } from "@steto-care/steto-query";

import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Logo } from "@/uiKit/atoms/Logo.tsx";

export type SideNavigationBarProps = PropsWithChildren<{
  userMenu: ReactNode;
  className?: string;
}>;

export const SideNavigationBar: React.FC<SideNavigationBarProps> = ({ userMenu, className, children }) => {
  const styles = useStyles(makeStyles);

  return (
    <nav className={cx(styles.container, className)} id="main-sidebar">
      <Logo className={styles.logo} />
      <div className={styles.items} id="main-sidebar-nav-items">
        <QueryAwait errorFallback={() => null} pendingFallback={() => null}>
          {children}
        </QueryAwait>
      </div>
      <div className={styles.foot} id="main-sidebar-footer">
        {userMenu}
      </div>
    </nav>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    width: ${theme.spacing(30)};
    height: 100%;
    z-index: ${theme.zIndex.appBar};
    border-right-width: 1px;
    border: ${theme.palette.common.white} solid;
    background-color: ${theme.palette.common.white};
  `,
  logo: css`
    margin-top: ${theme.spacing(4)};
    margin-bottom: ${theme.spacing(8)};
    padding-top: ${theme.spacing(4)};
  `,
  items: css`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  `,
  foot: css`
    display: flex;
    flex-direction: column;
    margin-bottom: ${theme.spacing(8)};
    gap: ${theme.spacing(8)};
  `,
});
